import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import Navbar from "./components/layouts/Navbar";
import Footer from "./components/layouts/Footer";
import ScrollToTop from "./components/layouts/ScrollToTop";

// Pages
import Homepage from "./components/Homepage/Homepage";
import Aboutpage from "./components/Aboutpage/Aboutpage";

// Products
import Productspage from "./components/ProductsPage/Productspage";
import ProductDetail from "./components/ProductsPage/ProductDetail";

// Services
import Servicespage from "./components/Servicespage/Servicespage";
import ServiceDetail from "./components/Servicespage/ServiceDetail";

// Web Solutions
import WebSolutionspage from "./components/Websolutions/WebSolutionspage";
import WebSolutionDetail from "./components/Websolutions/WebSolutionDetail";

// Others
import Contact from "./components/Contactpage/Contact";
import Career from "./components/Careerpage/Career";
import JobDetail from "./components/Careerpage/JobDetail";

// News / Blog
import News from "./components/News/News";
import BlogDetail from "./components/News/BlogDetail"; // ✅ NEW

import Blog from "./components/Blogpost/Blog";
import Blogcontent from "./components/Blogpost/Blogcontent";

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop /> {/* Ensures top scroll on every route change */}
      <Navbar />

      <Routes>
        {/* Home & About */}
        <Route path="/" element={<Homepage />} />
        <Route path="/about" element={<Aboutpage />} />

        {/* Products */}
        <Route path="/productpage" element={<Productspage />} />
        <Route path="/products/:group/:key" element={<ProductDetail />} />

        {/* Services */}
        <Route path="/servicespage" element={<Servicespage />} />
        <Route path="/services/:key" element={<ServiceDetail />} />

        {/* Web Solutions */}
        <Route path="/websolutionspage" element={<WebSolutionspage />} />
        <Route path="/websolutions/:key" element={<WebSolutionDetail />} />

        {/* Contact */}
        <Route path="/contact" element={<Contact />} />

        {/* Careers */}
        <Route path="/careers" element={<Career />} />
        <Route path="/careers/:id" element={<JobDetail />} />

          <Route path="/blog" element={<Blog />} />
        <Route path="/blog/:slug" element={<Blogcontent />} />
        

        {/* News / Blog */}
        <Route path="/news" element={<News />} />
        <Route path="/news/:slug" element={<BlogDetail />} /> {/* ✅ NEW */}
        
        {/* Optional 404 page */}
        {/* <Route path="*" element={<NotFound />} /> */}
      </Routes>

      <Footer />
    </BrowserRouter>
  );
}

export default App;
